import { BookOpen, Brain, ShieldCheck, TrendingUp } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { ChartMotif } from "./ChartMotif";
import { PHILOSOPHY, IMAGES } from "../../data/content";

const ICONS = { BookOpen, Brain, ShieldCheck, TrendingUp };

export const Philosophy = () => {
  return (
    <section id="trading" className="relative py-24 md:py-36 overflow-hidden">
      {/* subtle backdrop: Lamborghini interior — focus & control */}
      <div className="absolute inset-0 opacity-[0.08]">
        <img src={IMAGES.steeringWheel} alt="" className="w-full h-full object-cover grayscale" aria-hidden="true" />
      </div>
      <div className="absolute inset-0 bg-ink/88" />

      <div className="container-editorial relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7 max-w-3xl">
            <Reveal>
              <p className="overline mb-6">03 — Trading Philosophy</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
                The Mind Behind <br />
                the <span className="italic text-gold">Market.</span>
              </h2>
              <p className="mt-6 text-lg text-ash leading-relaxed">
                A framework built on preparation and restraint — not prediction. These are the
                principles that guide every decision.
              </p>
            </Reveal>
          </div>

          {/* animated chart motif */}
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="edit-card p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="overline">Approach · Trend</span>
                  <span className="font-mono text-xs text-gold">LONG-TERM</span>
                </div>
                <ChartMotif className="h-40 w-full" />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {PHILOSOPHY.map((c, i) => {
            const Icon = ICONS[c.icon] || TrendingUp;
            return (
              <Reveal key={c.title} delay={i * 0.08}>
                <div
                  data-testid={`philosophy-card-${i}`}
                  className="group relative bg-ink p-9 md:p-12 h-full transition-colors duration-500 hover:bg-white/[0.03]"
                >
                  <span className="absolute top-0 left-0 h-px w-0 bg-gold transition-all duration-500 group-hover:w-full" />
                  <div className="flex items-start justify-between">
                    <span className="flex h-12 w-12 items-center justify-center border border-gold/30 text-gold group-hover:bg-gold group-hover:text-ink transition-colors duration-500">
                      <Icon size={20} strokeWidth={1.6} />
                    </span>
                    <span className="font-mono text-xs text-gold">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h3 className="mt-8 font-serif text-2xl md:text-3xl text-bone tracking-tight">{c.title}</h3>
                  <p className="mt-4 text-ash leading-relaxed">{c.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
